export const iconFontAwesomeEducationBellSlash = (
	<i className="fa-solid fa-bell-slash"></i>
);
